import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadPixel, track } from "@/lib/meta";

/** One PageView per SPA route transition (browser only — server PageViews add no signal). */
export const MetaRouteTracking = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    loadPixel();
    track("PageView", {}, { browserOnly: true });
  }, [pathname, search]);
  return null;
};

export default MetaRouteTracking;
